import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';

import ModalWrapper from 'modules/shared/ModalWrapper';
import { useModal } from 'modules/shared/hooks';
import Clock from 'modules/kiosk/components/Clock';
import history from 'browserHistory';

import styles from './AttentionMsg.module.scss';

const AttentionMsg: React.FC = () => {
  const { isShow, openModal, closeModal } = useModal();

  const getTime = () => {
    const time = new Date();
    const h = time.getHours();
    const m = time.getMinutes();

    if (`${h}:${m}` === '23:49') openModal();
  };

  const handleCloseModal = () => {
    closeModal();
    history.push('/security/reports');
  };

  useEffect(() => {
    const timerID = setInterval(() => getTime(), 50000);

    return function cleanup() {
      clearInterval(timerID);
    };
  }, []);

  return (
    <ModalWrapper show={isShow} onHide={closeModal}>
      <div className="position-relative">
        <Clock className={classNames(styles.clock, 'h5')} />
        <h2 className="text-center text-danger mt-0 mb-1">Увага!</h2>
        <h5 className="text-center mt-0 mb-1">
          Перегляньте &quot;Звіт 2359&quot; і звільніть територію філії від транспорту, що завершив оформлення вантажу.
        </h5>
        <div className="d-flex justify-content-center my-3">
          <Button className="px-5" variant="outline-secondary" onClick={handleCloseModal}>
            Ok
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default AttentionMsg;
